import { ENDPOINTS } from "@/constants/endpoints"
import { FILTERS } from "@/constants/filters"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Survey } from "@/types/surveyTypes"

export const useSurveysData = () => {
  return useGenericQuery<Survey[]>({
    keys: QUERY_KEYS.surveys.index(),
    apiEndpoint: ENDPOINTS.surveys.index(),
    filterName: FILTERS.surveys.index(),
    paginated: true,
  })
}
export const useSingleSurveyData = (slug: string) => {
  return useGenericQuery<Survey>({
    keys: QUERY_KEYS.surveys.show(slug),
    apiEndpoint: ENDPOINTS.surveys.show(slug),
  })
}
